import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service'; 
@Component({
  selector: 'app-report-problem-view',
  templateUrl: './report-problem-view.component.html',
  styleUrls: ['./report-problem-view.component.scss']
})
export class ReportProblemViewComponent {
  ReportProblemForm: FormGroup = this.formBuilder.group({});
  reportProblemId:number =0;
  commonConstant:any=[];
  ReportProblemList:any=[];
  flag:boolean=false;

  constructor(
    private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.commonConstant = CommonConstant;
    this.getReportProblemDetail(this.reportProblemId);
  }
  
  getReportProblemDetail(reportProblemId: number) { 
    const apiUrl = this.apiUrl.apiUrl.reportProblem.GetReportProblemById.replace("{id}", reportProblemId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.ReportProblemList=data.data[0];
        this.spinner.hide();
        this.flag =true;
      },
      error: (err) => {
        this.spinner.hide();
        console.log('getGetUserById-Error', err);
      }
    });
  }
}
